import Spinner from 'react-bootstrap/Spinner'

function Loading() {

    return (
      <Spinner animation="border" variant="success" />
    );
}

export default Loading;